import React, { useEffect, useRef, useState } from 'react'
import styles from "./Toppanel.module.css"
import styles1 from "../pages/Dashboardcomponents/Environmentpanel.module.css"
import { ReactComponent as Icon } from "../Icon/circle-plus.svg"
import { ReactComponent as Icon1 } from "../Icon/createnewfile.svg"
import { ReactComponent as Icon2 } from "../Icon/upload.svg"
import { TbArrowBadgeRightFilled, TbTrash } from "react-icons/tb";
import { VscNewFile, VscCloudUpload, VscChevronRight, VscChevronDown, VscFileCode, VscFilePdf, VscFileMedia, VscFile, VscEllipsis, VscDebugStart, VscClose } from "react-icons/vsc";
import { create_project_file_Api, delete_project_file_Api, renameProjectFileApi, indexing_Project_File_Api } from '../dashboardapi'
import { IconButton, Button, useToast, Tooltip, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, Box, useDisclosure, Spinner, Flex, Text, VStack } from '@chakra-ui/react'
import CustomModal from "../pages/Dashboardcomponents/Modal"
import { useNavigate, useParams } from 'react-router-dom'
import UploadManager from './UploadManager'
import FileContextMenu from './FileContextMenu';

const Toppanel = (props) => {
    const [filetodelete, setFiletoDelete] = useState("")
    const [groupfiles, setGroupFiles] = useState("");
    const fileInputRef = useRef(null);
    const [openGroups, setOpenGroups] = useState({ tex: [] });
    // const [select, setSelect] = useState(false);
    // const [deleteFiles, setDeleteFiles] = useState([]);

    const [renamingFile, setRenamingFile] = useState(null);
    const [newFileName, setNewFileName] = useState("");
    // const [contextMenu, setContextMenu] = useState(null);
    const [fileUploadShow, setFileUploadShow] = useState(false);
    const [showUploadManager, setShowUploadManager] = useState(false);
    const [dragging, setDragging] = useState(false);
    const [projectFiles, setProjectFiles] = useState([]);
    // const [uploading, setUploading] = useState(null); loader for upload in modal
    // const [showMore, setShowMore] = useState(false);
    const [currentFileIndex, setCurrentFileIndex] = useState(-1);
    const [searchTerm, setSearchTerm] = useState("");

    const [indexFile, setIndexFile] = useState("");
    const [indexRes, setIndexRes] = useState();
    // const [name, setName] = useState([]);
    const toast = useToast();
    const moreref = useRef();
    const navigate = useNavigate();


    useEffect(() => {
        const moreClick = (e) => {
            if (moreref.current && !moreref.current.contains(e.target) && !e.target.closest(".morebtn")) {
                setCurrentFileIndex(-1);
            }
        }

        document.addEventListener("click", moreClick);
        return () => document.removeEventListener("click", moreClick)
    })


    const {
        isOpen: alertOpen,
        onToggle: onalertToogle,
        onClose: onalertClose,
    } = useDisclosure();

    //MARK:Handle upload
    const handleFiles = async (files) => {
        const fileslist = Array.from(files);
        if (!fileslist.length) return;
        setProjectFiles(fileslist);// array of files
        setFileUploadShow(true);//state to Trigger file input click
    }

    const handleUpload = () => {
        if (!projectFiles.length) {
            toast({
                title: "No files selected",
                description: "Please choose a file to upload.",
                status: "warning",
                duration: 2000,
                isClosable: true,
            });
            return;
        }
        setShowUploadManager(true); // Show UploadManager modal
        toast({
            title: "Uploading...",
            description: `Uploading ${projectFiles.length} file(s)`,
            status: "info",
            duration: 2000,
            isClosable: true,
        });

    };


    const handleClick = () => {
        // Trigger file input click
        setFileUploadShow(true)
    };

    const triggerInputClick = () => {
        fileInputRef.current.click();
    }

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragging(true); // Highlight the area when dragging files
    };

    const handleDragLeave = () => {
        setDragging(false); // Remove highlight when leaving
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragging(false);
        const files = e.dataTransfer.files;
        handleFiles(files); // only preview
    };

    //MARK:create file
    const createFile = async () => {
        let count = 0;
        let num;
        let regex = /^main(\d+)*\.tex/g
        if (props.projectfiles) {
            props.projectfiles.uploads.forEach(element => {
                let res
                while ((res = regex.exec(element.name)) !== null) {
                    if (res[1] === undefined) {
                        count = 1;

                    } else {
                        num = parseInt(res[1])
                        num = Math.max(num)
                        count = num + 1;
                    }
                }
            }
            )
        }
        let name = `main${count}.tex`

        try {
            // Attempt to create the new file
            let result = await create_project_file_Api(props.projectid, name);
            if (result.data) {
                toast({
                    title: "File Created",
                    description: "Tex file created successfully",
                    status: "success",
                    duration: 2000,
                    isClosable: "true"

                })
                props.loadProjectDetails();
            } else {
                let error = result.error.Message || "An error occurred";
                toast({
                    title: "Problem creating file",
                    description: error,
                    duration: 2000,
                    isClosable: "true"

                })
            }
        } catch (error) {
            toast({
                title: "Problem creating file",
                description: "tex file not created, try again later.",
                status: 'error',
                duration: 2000,
                isClosable: "true"

            })
        }
    };

    //shortcut for new file creation
    useEffect(() => {
        const handleKeyDown = (e) => {
            if ((e.ctrlKey || e.metaKey) && e.key === "F2") {
                e.preventDefault();
                createFile(); // call the same function used by the button
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [createFile]);


    //MARK:Handle Dlt
    const { file } = useParams();
    const handleDeleteClick = (items) => {
        setFiletoDelete(items);
        onalertToogle();
    }
    const handleDelete = async (project_id, fileid, fileName) => {
        toast({
            title: "Deleting file",
            description: "File deletion in progress",
            status: "loading",
            isClosable: "true"

        })
        try {
            let result = await delete_project_file_Api(project_id, fileid);
            if (result.data) {
                toast.closeAll();
                toast({
                    title: "File Deleted",
                    description: "File deleted Successfully",
                    status: "success",
                    duration: 2000,
                    isClosable: "true"
                })
                props.loadProjectDetails();
                if (fileName === file)
                    navigate(`/${props.projectid}/`, { replace: false })

            } else {
                let error = result.error.message || "An error occurred";
                toast({
                    title: "Problem deleting file",
                    description: error,
                    duration: 2000,
                    isClosable: "true"

                })
            }
        } catch (e) {
            toast({
                title: "Problem deleting file",
                description: "tex file not deleted, try again later.",
                status: 'error',
                duration: 2000,
                isClosable: "true"

            })
        }
    }


    const toggleGroup = (extension) => {
        setOpenGroups(prevState => ({
            ...prevState,
            [extension]: !prevState[extension], // Toggle the open/close state of file groups
        }));
    };

    useEffect(() => {
        if (!props.projectfiles.uploads) {
            return; // Or return a loading state
        }

        const group = props.projectfiles.uploads?.reduce((groups, file) => {
            const extension = file.name.split(".").pop()
            if (!groups[extension]) groups[extension] = [];
            groups[extension].push(file);
            return groups;
        }, {});

        const preferredOrder = ["tex", "bib", "jpg", "jpeg", "png", "eps", "pdf"];

        let sorted_group = Object.entries(group).sort((a, b) => {
            let typea = preferredOrder.indexOf(a[0]);
            let typeb = preferredOrder.indexOf(b[0]);
            if (typea !== -1 && typeb !== -1) {
                return typea - typeb;
            }
            if (typea !== -1) return -1;
            if (typeb !== -1) return 1;
            return a[0].localeCompare(b[0])
        })
        setGroupFiles(sorted_group);

    }, [props.projectfiles])


    const handleRenameClick = (file) => {
        setRenamingFile(file.name);
        setNewFileName(file.name);
    };

    const handleRenameSubmit = (event, oldfile) => {
        event.preventDefault();
        if (newFileName.trim() && newFileName !== oldfile.name) {
            handleRename(oldfile, newFileName);
        }
        setRenamingFile(null);
        if (file == oldfile.name)
            navigate(`/${props.projectid}/${newFileName}`, { replace: false })

    };

    const handleRename = async (file, newFileName) => {
        toast({
            title: "Renaming file",
            description: "Please wait..",
            status: 'info',
            isClosable: true,
            icon: (
                <Spinner
                    thickness="4px"
                    emptyColor="gray.200"
                    color="blue.500"
                    size="sm"
                />
            ),
        })
        let response = await renameProjectFileApi(props.projectid, file.uuid, newFileName);
        if (response.data) {
            props.loadProjectDetails();
            toast.closeAll();
        } else {
            toast({
                title: "Problem renaming file",
                description: "There is a problem renaming file please try again later.",
                status: 'error',
                isClosable: true,
                duration: 2000,
            })
        }
    }

    const handleShowMore = (i, items) => {
        if (currentFileIndex !== items.uuid) {
            setCurrentFileIndex(-1)
            setCurrentFileIndex(items.uuid)
        } else {
            setCurrentFileIndex(-1);
        }
    }

    //MARK:Handle indexing
    const handleIndexing = async (file) => {


        if (!file.name.endsWith(".tex")) {
            toast({
                title: "Indexing Error",
                description: "Only .tex files can be indexed",
                status: "warning",
                duration: 2000,
                isClosable: true,
            });
            return;
        }
        setIndexFile(file);
        try {
            const indexed = await indexing_Project_File_Api(props.projectid, file.uuid);
            setIndexRes(indexed);

            toast({
                title: "File Indexing",
                description: `${file.name} is the index file now`,
                status: "info",
                duration: 2000,
                isClosable: true,
            });

            // setProjectFiles(prev =>prev.map)
        } catch (error) {
            toast({
                title: "Failed to set index file",
                description: error.message || "An unexpected error occurred.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    }
    useEffect(() => { props.loadProjectDetails() }, [indexFile, indexRes, projectFiles]);

    return (
        <Box className={styles.toppanel_outer} h="100%" bg="#252526" color="#cccccc" display="flex" flexDirection="column" userSelect="none">
            {/* Header Actions */}
            <Flex
                align="center"
                justify="space-between"
                px={2}
                py={2}
                minH="35px"
                bg="#252526"
                borderBottom="1px solid #3e3e42"
            >
                <Box flex={1} mr={2} position="relative">
                    <input
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                            width: "100%",
                            backgroundColor: "#3c3c3c",
                            border: "1px solid #3c3c3c",
                            color: "#cccccc",
                            padding: "2px 24px 2px 6px", // Extra padding right for icon
                            borderRadius: "2px",
                            fontSize: "13px",
                            outline: "none"
                        }}
                    />
                    {searchTerm && (
                        <Box
                            position="absolute"
                            right="4px"
                            top="50%"
                            transform="translateY(-50%)"
                            cursor="pointer"
                            onClick={() => setSearchTerm("")}
                            color="#cccccc"
                            _hover={{ color: "white" }}
                        >
                            <VscClose size="14px" />
                        </Box>
                    )}
                </Box>
                <Flex gap={3} color="#cccccc" flexShrink={0} align="center">
                    <Tooltip label="New File" hasArrow placement="bottom">
                        <Box cursor="pointer" onClick={createFile} _hover={{ color: "white" }}>
                            <VscNewFile size="18px" />
                        </Box>
                    </Tooltip>
                    <Tooltip label="Upload Files" hasArrow placement="bottom">
                        <Box cursor="pointer" onClick={handleClick} _hover={{ color: "white" }}>
                            <VscCloudUpload size="18px" />
                        </Box>
                    </Tooltip>
                    <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        multiple
                        onChange={(e) => handleFiles(e.target.files)}
                        accept=".txt, .tex, .bib, .pdf, .png, .jpg, .jpeg, .dtx, .ins, .bst, .sty, .eps, .cls"
                    />
                </Flex>
            </Flex>

            {/* File List */}
            <Box flex={1} overflowY="auto" pt={1}>
                {groupfiles && groupfiles.map(([ext, files], index) => {
                    // Filter files based on search term
                    const filteredFiles = files.filter(f => f.name.toLowerCase().includes(searchTerm.toLowerCase()));
                    if (filteredFiles.length === 0 && searchTerm) return null; // Hide group if no matches

                    const isOpen = openGroups[ext] || searchTerm; // Auto-expand on search
                    return (
                        <Box key={index} w="100%">
                            {/* Group Header */}
                            <Flex
                                align="center"
                                py="4px"
                                px="8px"
                                cursor="pointer"
                                onClick={() => toggleGroup(ext)}
                                _hover={{ bg: "#2a2d2e" }}
                                color="#cccccc"
                                fontWeight="bold"
                                fontSize="14px"
                            >
                                <Box mr={1}>
                                    {isOpen ? <VscChevronDown size="16px" /> : <VscChevronRight size="16px" />}
                                </Box>
                                <Text textTransform="uppercase" fontSize="12px" fontWeight="bold" letterSpacing="0.05em">
                                    {ext}
                                </Text>
                            </Flex>

                            {/* Files in Group */}
                            {isOpen && filteredFiles.map((item, i) => {
                                const isSelected = item.name === props.current_file;
                                const isTex = item.name.endsWith('.tex') || item.name.endsWith('.bib');
                                const isPdf = item.name.endsWith('.pdf');
                                const isImage = item.name.match(/\.(jpg|jpeg|png|eps)$/i);

                                let FileIcon = VscFile;
                                if (isTex) FileIcon = VscFileCode;
                                if (isPdf) FileIcon = VscFilePdf;
                                if (isImage) FileIcon = VscFileMedia;

                                return (
                                    <Flex
                                        key={i}
                                        align="center"
                                        justify="space-between"
                                        pl="24px"
                                        pr="8px"
                                        py="3px"
                                        cursor="pointer"
                                        bg={isSelected ? "#37373d" : "transparent"}
                                        borderLeft={isSelected ? "2px solid #007fd4" : "2px solid transparent"}
                                        _hover={{ bg: isSelected ? "#37373d" : "#2a2d2e" }}
                                        position="relative"
                                        onClick={() => {
                                            if (isTex) {
                                                navigate(`/${props.projectid}/${item.name}`, { replace: false });
                                            } else if (isPdf || isImage) {
                                                toast({
                                                    title: "Feature to View Upcoming",
                                                    status: 'info',
                                                    duration: 1000
                                                });
                                            } else {
                                                toast({
                                                    title: "File Not Supported",
                                                    status: 'warning',
                                                    duration: 1000
                                                });
                                            }
                                        }}
                                        className="file-item-row" // Helper for selection
                                    >
                                        <Flex align="center" flex={1} overflow="hidden">
                                            <Box mr={2} color={isTex ? "#519aba" : "#cccccc"}>
                                                <FileIcon size="14px" />
                                            </Box>

                                            {renamingFile === item.name ? (
                                                <form onSubmit={(e) => handleRenameSubmit(e, item)} style={{ flex: 1 }}>
                                                    <input
                                                        type="text"
                                                        value={newFileName}
                                                        onChange={(e) => setNewFileName(e.target.value)}
                                                        autoFocus
                                                        onBlur={() => setRenamingFile(null)}
                                                        onClick={(e) => e.stopPropagation()}
                                                        style={{
                                                            width: "100%",
                                                            background: "#3c3c3c",
                                                            color: "white",
                                                            border: "1px solid #007fd4",
                                                            outline: "none",
                                                            fontSize: "13px",
                                                            padding: "1px 4px"
                                                        }}
                                                    />
                                                </form>
                                            ) : (
                                                <Text
                                                    fontSize="13px"
                                                    color={isSelected ? "white" : "#cccccc"}
                                                    isTruncated
                                                    flex={1}
                                                >
                                                    {item.name}
                                                </Text>
                                            )}

                                            {item.is_index && (
                                                <Tooltip label="Index File">
                                                    <Box ml={1}><VscDebugStart color="#d4b600" size="14px" /></Box>
                                                </Tooltip>
                                            )}
                                        </Flex>

                                        {/* More Options Trigger */}
                                        <Box
                                            className="morebtn"
                                            onClick={(e) => { e.stopPropagation(); handleShowMore(i, item); }}
                                            p={1}
                                            borderRadius="md"
                                            _hover={{ bg: "rgba(255,255,255,0.1)" }}
                                            opacity={currentFileIndex === item.uuid ? 1 : 0} // Show if active, or use CSS hover to show
                                            sx={{
                                                ".file-item-row:hover &": { opacity: 1 }
                                            }}
                                        >
                                            <VscEllipsis size="14px" />
                                        </Box>

                                        {/* Context Menu */}
                                        {currentFileIndex === item.uuid && (
                                            <FileContextMenu
                                                ref={moreref}
                                                file={item}
                                                onMarkAsIndex={() => handleIndexing(item)}
                                                onRename={() => handleRenameClick(item)}
                                                onDelete={() => handleDeleteClick(item)}
                                            />
                                        )}
                                    </Flex>
                                );
                            })}
                        </Box>
                    );
                })}
                {(!groupfiles || groupfiles.length === 0) && (
                    <Flex justify="center" align="center" h="100px" color="#666">
                        <Text fontSize="12px">No files in project</Text>
                    </Flex>
                )}
            </Box>

            {/* Modals - Kept as is */}
            <Modal isOpen={alertOpen} onClose={onalertClose} isCentered size="sm">
                <ModalOverlay />
                <ModalContent bg="#252526" color="white" border="1px solid #454545">
                    <ModalHeader fontSize="14px">Delete '{filetodelete.name}'?</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text fontSize="13px" mb={4}>Are you sure you want to delete this file?</Text>
                        <Flex justify="flex-end" gap={2} mb={2}>
                            <Button size="sm" variant="ghost" onClick={onalertClose} _hover={{ bg: "#3e3e42" }} color="white">Cancel</Button>
                            <Button size="sm" colorScheme="red" onClick={() => { handleDelete(props.projectid, filetodelete.uuid, filetodelete.name); onalertClose() }}>Delete</Button>
                        </Flex>
                    </ModalBody>
                </ModalContent>
            </Modal>

            <CustomModal show={fileUploadShow}>
                <div className={styles1.modalouter}>
                    {showUploadManager ? (
                        <UploadManager
                            projectId={props.projectid}
                            files={projectFiles}
                            apiFunc={create_project_file_Api}
                            onClose={() => {
                                setShowUploadManager(false);
                                setFileUploadShow(false);
                                setProjectFiles([]);
                            }}
                        />
                    ) : (
                        <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "24px" }}>
                            {/* Keep existing upload UI structure but verify it works with styles1 */}
                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px" }}>
                                <div className={styles1.modalheader}><p>Upload files</p></div>
                                <button onClick={() => setFileUploadShow(false)} style={{ padding: "5px 10px" }}>Close</button>
                            </div>
                            <div style={{ display: "flex", gap: "24px" }}>
                                <div style={{ width: "50%" }}>
                                    <form className={styles1.formouter} method="POST">
                                        <div
                                            className={`${styles1.inputdiv} ${dragging ? styles1.dragging : ''}`}
                                            onDragOver={handleDragOver}
                                            onDragLeave={handleDragLeave}
                                            onDrop={handleDrop}
                                        >
                                            {dragging ? (
                                                <div style={{ height: "133px" }}>Drop your files here</div>
                                            ) : (
                                                <>
                                                    <p>
                                                        {/* <img
                                                            src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/upload_img.png"}
                                                            alt=""
                                                        /> */}
                                                        <svg width="47" height="42" viewBox="0 0 47 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M30.9463 3.77734C31.3003 3.77734 31.5879 4.06488 31.5879 4.41895C31.5879 4.773 31.3004 5.06055 30.9463 5.06055C28.2931 5.06073 25.9029 6.77951 25.0469 9.27051L24.9688 9.51367C24.8781 9.81953 24.5795 10.005 24.2715 9.96387L24.2637 9.97363L24.1719 9.94531C23.8327 9.84417 23.6391 9.4879 23.7402 9.14844C24.6617 6.052 27.5312 3.77753 30.9463 3.77734Z" fill="var(--btn-bg)" stroke="#F9FFF9" stroke-width="0.3" />
                                                            <path d="M37.8229 28.4884H34.8757C34.6045 28.4884 34.3845 28.2684 34.3845 27.9972C34.3845 27.726 34.6045 27.506 34.8757 27.506H37.8229C41.8854 27.506 45.1909 24.2005 45.1909 20.138C45.1909 16.0754 41.8854 12.7699 37.8229 12.7699H37.752C37.6096 12.7699 37.4741 12.7082 37.3808 12.6005C37.2875 12.4928 37.2454 12.35 37.2657 12.2089C37.3096 11.903 37.3317 11.5956 37.3317 11.2963C37.3317 7.77549 34.4669 4.91068 30.946 4.91068C29.5763 4.91068 28.27 5.33873 27.1683 6.14885C26.9262 6.32674 26.5823 6.2478 26.4424 5.98149C23.3222 0.0400754 15.1726 -0.757796 10.9475 4.41072C9.16764 6.58813 8.4683 9.42061 9.02869 12.1812C9.09044 12.4861 8.85711 12.7703 8.54731 12.7703H8.35047C4.28792 12.7703 0.982451 16.0758 0.982451 20.1383C0.982451 24.2009 4.28792 27.5064 8.35047 27.5064H11.2976C11.5689 27.5064 11.7889 27.7263 11.7889 27.9976C11.7889 28.2688 11.5689 28.4888 11.2976 28.4888H8.35047C3.74612 28.4888 0 24.7427 0 20.1383C0 15.6631 3.53873 11.9987 7.96488 11.7966C7.54911 8.93254 8.34416 6.04357 10.1868 3.789C14.7104 -1.74508 23.3796 -1.12478 27.0443 5.04612C28.2134 4.31317 29.5511 3.92867 30.9459 3.92867C35.2116 3.92867 38.5918 7.55937 38.296 11.8012C42.6814 12.0472 46.1731 15.6922 46.1731 20.1379C46.1731 24.7427 42.427 28.4884 37.8227 28.4884L37.8229 28.4884Z" fill="var(--btn-bg)" />
                                                            <path d="M37.8229 28.4884H34.8757C34.6045 28.4884 34.3845 28.2684 34.3845 27.9972C34.3845 27.726 34.6045 27.506 34.8757 27.506H37.8229C41.8854 27.506 45.1909 24.2005 45.1909 20.138C45.1909 16.0754 41.8854 12.7699 37.8229 12.7699H37.752C37.6096 12.7699 37.4741 12.7082 37.3808 12.6005C37.2875 12.4928 37.2454 12.35 37.2657 12.2089C37.3096 11.903 37.3317 11.5956 37.3317 11.2963C37.3317 7.77549 34.4669 4.91068 30.946 4.91068C29.5763 4.91068 28.27 5.33873 27.1683 6.14885C26.9262 6.32674 26.5823 6.2478 26.4424 5.98149C23.3222 0.0400754 15.1726 -0.757796 10.9475 4.41072C9.16764 6.58813 8.4683 9.42061 9.02869 12.1812C9.09044 12.4861 8.85711 12.7703 8.54731 12.7703H8.35047C4.28792 12.7703 0.982451 16.0758 0.982451 20.1383C0.982451 24.2009 4.28792 27.5064 8.35047 27.5064H11.2976C11.5689 27.5064 11.7889 27.7263 11.7889 27.9976C11.7889 28.2688 11.5689 28.4888 11.2976 28.4888H8.35047C3.74612 28.4888 0 24.7427 0 20.1383C0 15.6631 3.53873 11.9987 7.96488 11.7966C7.54911 8.93254 8.34416 6.04357 10.1868 3.789C14.7104 -1.74508 23.3796 -1.12478 27.0443 5.04612C28.2134 4.31317 29.5511 3.92867 30.9459 3.92867C35.2116 3.92867 38.5918 7.55937 38.296 11.8012C42.6814 12.0472 46.1731 15.6922 46.1731 20.1379C46.1731 24.7427 42.427 28.4884 37.8227 28.4884L37.8229 28.4884Z" fill="var(--btn-bg)" />
                                                            <path d="M23.0205 14.6895C30.206 14.6895 36.0508 20.5342 36.0508 27.7197C36.0507 34.9051 30.206 40.75 23.0205 40.75C15.8351 40.75 9.99028 34.9053 9.99023 27.7197C9.99023 20.5343 15.8349 14.6895 23.0205 14.6895ZM23.0205 17.1719C17.2053 17.1719 12.4727 21.9046 12.4727 27.7197C12.4727 33.5349 17.2054 38.2676 23.0205 38.2676C28.8356 38.2675 33.5683 33.5348 33.5684 27.7197C33.5684 21.9045 28.8356 17.1719 23.0205 17.1719Z" fill="var(--btn-bg)" stroke="#F9FFF9" stroke-width="1.5" />
                                                            <path d="M23.2444 33.0224C23.0458 33.0224 22.8848 32.8614 22.8848 32.6628V23.3127C22.8848 23.1142 23.0458 22.9531 23.2444 22.9531C23.4429 22.9531 23.604 23.1142 23.604 23.3127V32.6628C23.604 32.8616 23.4429 33.0224 23.2444 33.0224Z" fill="var(--btn-bg)" />
                                                            <path d="M26.1213 26.5503C26.0294 26.5503 25.9371 26.5151 25.867 26.445L23.2444 23.8224L20.6218 26.445C20.4815 26.5855 20.2537 26.5855 20.1132 26.445C19.9727 26.3045 19.9727 26.0769 20.1132 25.9364L22.9901 23.0595C23.1303 22.919 23.3582 22.919 23.4987 23.0595L26.3756 25.9364C26.5161 26.0769 26.5161 26.3045 26.3756 26.445C26.3055 26.5154 26.2132 26.5503 26.1213 26.5503H26.1213Z" fill="var(--btn-bg)" />
                                                        </svg>

                                                    </p>
                                                    <div>Upload your files</div>
                                                    <p>
                                                        Drag and drop your files here or{" "}
                                                        <a onClick={triggerInputClick}>choose files</a>
                                                    </p>
                                                    <input
                                                        type="file"
                                                        ref={fileInputRef}
                                                        style={{ display: "none" }}
                                                        multiple
                                                        onChange={(e) => handleFiles(e.target.files)}
                                                        accept=".txt, .tex, .bib, .pdf, .png, .jpg, .jpeg, .dtx, .ins, .bst, .sty, .eps, .cls"
                                                    />
                                                </>
                                            )}
                                        </div>
                                    </form>
                                </div>
                                <div style={{ width: "50%", borderLeft: "1px solid var(--border)", paddingLeft: "24px", maxHeight: "400px", overflowY: "scroll" }}>
                                    {projectFiles.length > 0 ? (
                                        projectFiles?.map((file, i) => (
                                            <Box key={i}
                                                display="flex"
                                                alignItems="flex-start"
                                                justifyContent="space-between"
                                                w="100%"
                                                p={4}
                                                border="1px solid var(--border)"
                                                borderRadius="md"
                                            >
                                                <VStack align="start" spacing={1} w="70%">
                                                    <Text fontSize="md" fontWeight="500" wordBreak="break-word">
                                                        {file.name}
                                                    </Text>
                                                    <Text fontSize="0.75rem" color="var(--text-secondary)">
                                                        {(file.size / 1024).toFixed(2)} KB
                                                    </Text>
                                                </VStack>
                                                <Button variant="ghost" p={0} ml={2} onClick={() => setProjectFiles(projectFiles.filter((_, idx) => idx !== i))}>
                                                    {/* <img
                                                        src="/images/Redesignpics/Dashboard/delete.png"
                                                        alt="delete"
                                                        boxSize="20px"
                                                    /> */}
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_45_3546)">
                                                            <path d="M3.33398 5.83301H16.6673" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M8.33398 9.16699V14.167" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M11.666 9.16699V14.167" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M4.16602 5.83301L4.99935 15.833C4.99935 16.275 5.17494 16.699 5.4875 17.0115C5.80006 17.3241 6.22399 17.4997 6.66602 17.4997H13.3327C13.7747 17.4997 14.1986 17.3241 14.5112 17.0115C14.8238 16.699 14.9993 16.275 14.9993 15.833L15.8327 5.83301" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_45_3546">
                                                                <rect width="20" height="20" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                </Button>
                                            </Box>)
                                        )
                                    ) : (
                                        <Text color="var(--text-secondary)">No file selected</Text>
                                    )}
                                </div>
                            </div>
                            {/* Footer: Common Upload button */}
                            <Box mt={6} display="flex" justifyContent="flex-end">
                                <Button
                                    bg="var(--btn-bg)"
                                    color="var(--btn-text)"
                                    onClick={handleUpload}
                                    // isLoading={uploading}
                                    loadingText="Uploading"
                                    _hover={{ bg: "var(--btn-hover)" }}
                                >
                                    Upload
                                </Button>
                            </Box>
                        </div>
                    )}
                </div>
            </CustomModal>
        </Box>
    )
}

export default Toppanel;